import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, catchError, map, Observable, of, tap } from 'rxjs';
import { EntidadPortal } from '../interfaces/entidad-portal';
import { EntidadContextService } from '@shared-services/entidad-context.service';

@Injectable({
  providedIn: 'root',
})
export class PortalService {
  private readonly apiUrl = `${environment.API_SERVER}/portal`;

  private _currentEntity = new BehaviorSubject<EntidadPortal | null>(null);
  public currentEntity$ = this._currentEntity.asObservable();

  constructor(private http: HttpClient, private entidadContext: EntidadContextService) {}

  setCurrentEntity(entity: EntidadPortal | null) {
    this._currentEntity.next(entity);
    this.entidadContext.set(
      entity
        ? {
            id: entity.id,
            entidadId: entity.id.toString(),
            codigoEntidadExternoId: entity.codigoEntidadExternoId,
            slug: entity.slug,
          }
        : null,
    );
  }

  getCurrentEntityValue(): EntidadPortal | null {
    return this._currentEntity.value;
  }

  getMunicipios(): Observable<EntidadPortal[]> {
    return this.http.get<EntidadPortal[]>(`${this.apiUrl}/municipios`);
  }

  getInfoPortal(slug: string): Observable<EntidadPortal> {
    const current = this._currentEntity.value;

    console.log('current', current);

    if (current && current.slug === slug && current.imagenPortadaUrl !== undefined) {
      console.log('✅ [PortalService] Usando caché memoria para:', slug);
      return of(current);
    }

    console.log('🔄 [PortalService] Descargando datos frescos para:', slug);
    return this.http.get<any>(`${this.apiUrl}/municipios/${slug}`).pipe(
      map((res) => this.mapToEntidad(res)),
      tap((entity) => {
        this.setCurrentEntity(entity);
      }),
    );
  }
  private mapToEntidad(m: any): EntidadPortal {
    return {
      id: m.ID || m.id,
      slug: (m.SLUG || m.slug || '').toLowerCase(),
      nombre: m.NOMBRE || m.nombre,

      direccion: m.DIRECCION || m.direccion,
      telefono: m.TELEFONO || m.telefono,
      horarioAtencion: m.HORARIO_ATENCION || m.horarioAtencion,
      urlMunicipio: m.URL_MUNICIPIO || m.urlMunicipio,

      logoUrl: m.LOGO_URL || m.logoUrl,
      imagenPortadaUrl: m.IMAGEN_PORTADA_URL || m.imagenPortadaUrl,
      colorPrimario: m.COLOR_PRIMARIO || m.colorPrimario || '#3B82F6',
      codigoEntidadExternoId: m.CODIGO_ENTIDAD_EXTERNO_ID || m.codigoEntidadExternoId,

      tituloPrincipal:
        m.TITULO_PORTADA ||
        m.tituloPortada ||
        m.TITULO_PRINCIPAL ||
        m.tituloPrincipal ||
        m.NOMBRE ||
        m.nombre,
      subtituloPortada: m.SUBTITULO_PORTADA || m.subtituloPortada,

      // Redes
      facebookUrl: m.FACEBOOK_URL || m.facebookUrl,
      instagramUrl: m.INSTAGRAM_URL || m.instagramUrl,
      mostrarNoticias: m.MOSTRAR_NOTICIAS || m.mostrarNoticias,
    };
  }
  getNoticias(slug: string): Observable<any[]> {
    console.log(slug);

    return this.http.get<any[]>(`${this.apiUrl}/municipios/${slug}/noticias`);
  }

  checkModuloAccess(slug: string, modulo: string = 'LOGIN'): Observable<boolean> {
    if (!slug) return of(true);

    // En desarrollo local la IP de la maquina no esta en la lista blanca del
    // backend y el endpoint responde 403, lo que ocultaria el modulo. Se omite
    // la validacion solo cuando se sirve desde localhost.
    // if (this.esEntornoLocal()) return of(true);

    return this.http
      .get<{ allowed: boolean }>(`${this.apiUrl}/${slug}/check-access?modulo=${modulo}`)
      .pipe(
        map((res) => res.allowed),
        catchError(() => of(false)),
      );
  }

  private esEntornoLocal(): boolean {
    return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
  }
}
